import querystring from 'querystring';
import getDataEnvironment from '@tools/getDataEnvironment';
import getConfig from 'next/config';
import useMeQuery from './useMeQuery';

const { publicRuntimeConfig } = getConfig();

const useRegLink = () => {
  const { data } = useMeQuery();
  const { event, ...me } = data?.me || {
    id: undefined
  };

  // Do not return this link when the event is in "standalone" mode
  if (!event?.features?.registration) {
    return '';
  }

  let registrationQuery = querystring.stringify({
    inviteeId: me?.id
  });

  const environment = getDataEnvironment();
  if (environment) {
    registrationQuery += `&${querystring.stringify({
      environment
    })}`;
  }

  return `${publicRuntimeConfig.EVENT_GUESTSIDE_DOMAIN}/event/${event?.id}/alreadyRegistered?${registrationQuery}`;
};

export default useRegLink;
